import { useLocalSearchParams } from 'expo-router';

import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const { assetId } = useLocalSearchParams<{ assetId: string }>();

  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>Gift Card Checkout — {assetId}</ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton />
    </ExpoRouterDemoScreen>
  );
}
